const SALARIES_ENDPOINTS = {
    // Search
    SALARIES: "/frontend/hospital-salary/filter",
    PUBLIC_SALARIES:"/frontend/public/hospital-salary/filter",
    // Free-tier daily input-change usage (1 change/day for free users).
    USAGE: "/frontend/hospital-salary/usage",
    // Distinct states in the hospital salary table.
    STATES: "/frontend/hospital-salary/states",
};

export default SALARIES_ENDPOINTS;